const config = {
  RELATIVE_URL_PATH: import.meta.env.VITE_RELATIVE_URL_PATH,
  STAGE: import.meta.env.VITE_STAGE,
  API_DOMAIN_URL: import.meta.env.VITE_API_DOMAIN_URL,
  AWS_REGION: import.meta.env.VITE_AWS_REGION,
  AWS_RUM_AUTH_IDENTITY_POOL_ID: import.meta.env.VITE_AWS_RUM_AUTH_IDENTITY_POOL_ID,
  AWS_RUM_UNAUTH_IDENTITY_POOL_ID: import.meta.env.VITE_AWS_RUM_UNAUTH_IDENTITY_POOL_ID,
  AWS_RUM_GUEST_ROLE: import.meta.env.VITE_AWS_RUM_GUEST_ROLE,
  AWS_RUM_AUTH_MONITOR_ID: import.meta.env.VITE_AWS_RUM_AUTH_MONITOR_ID,
  AWS_RUM_UNAUTH_MONITOR_ID: import.meta.env.VITE_AWS_RUM_UNAUTH_MONITOR_ID,
  AWS_USER_POOL_ID: import.meta.env.VITE_AWS_USER_POOL_ID,
  AWS_COGNITO_DOMAIN_URL: import.meta.env.VITE_AWS_COGNITO_DOMAIN_URL,
  AWS_USER_POOL_WEB_CLIENT_ID: import.meta.env.VITE_AWS_USER_POOL_WEB_CLIENT_ID,
  GRAPHQL_TRANSFORMATION_LAYER: import.meta.env.VITE_GRAPHQL_TRANSFORMATION_LAYER,
  GOOGLE_ANALYTICS_UA: import.meta.env.VITE_GOOGLE_ANALYTICS_UA,
  VISUAL_PING_TOKEN: import.meta.env.VITE_VISUAL_PING_TOKEN,
  LOGROCKET_PROJECT_ID: import.meta.env.VITE_LOGROCKET_PROJECT_ID,
  SPREADJS_KEY: import.meta.env.VITE_SPREADJS_KEY,
  IS_PRODUCTION: import.meta.env.NODE_ENV === 'production',
  OAUTH_REDIRECT_SIGN_IN: import.meta.env.VITE_OAUTH_REDIRECT_SIGN_IN,
  OAUTH_REDIRECT_SIGN_OUT: import.meta.env.VITE_OAUTH_REDIRECT_SIGN_OUT,
  OAUTH_SERVER_URL: import.meta.env.VITE_OAUTH_SERVER_URL,
  DEBUG_EVENT_BUS: import.meta.env.VITE_DEBUG_EVENT_BUS,
  CHAT_APP_API_ARN: import.meta.env.VITE_CHAT_APP_API_ARN,
}

// Old API used to be in api.<env>.cognitivecredit.com
// We are moving toward <env>.cognitivecredit.com/api as a better (no CORS!) setup but we need to support both for now until the old one is fully deprecated and removed.
// A reverse proxy  ( <env>.cognitivecredit.com/api -> api.<env>.cognitivecredit.com ) has been setup in order to move toward that goal on the old gateway.
// PORTED_PREFIXES      New API gateway, new adressing scheme: <env>.cognitivecredit.com/api/<service-name>/<endoints>
// LEGACY_API_PREFIXES  Old API gateway, new adressing scheme: <env>.cognitivecredit.com/api/old/<service-name>/<endoints>
// Anything not in either of those lists is assumed to be on the old API gateway with the old adressing scheme: api.<env>.cognitivecredit.com/<service-name>/<endoints>
const PORTED_PREFIXES: string[] = [
  'company-permissioning-service',
  'comps',
  'data-checks',
  'fx-sync',
  'pdftools',
  'api-data-pipeline-runner',
  'eng-watermark-removal',
  'api-text-extract',
]
const LEGACY_API_PREFIXES: string[] = []
export const getApiDomain = (prefix: string, useStage = true) => {
  const location = window.location
  const isLocal = location.hostname === 'localhost' || location.hostname === '127.0.0.1'
  if (PORTED_PREFIXES.includes(prefix)) {
    if (isLocal) {
      return `https://${useStage ? config.STAGE : 'dev'}.cognitivecredit.com/api`
    } else {
      return `${location.origin}/api`
    }
  } else if (LEGACY_API_PREFIXES.includes(prefix)) {
    return isLocal
      ? `https://${useStage ? config.STAGE : 'dev'}.cognitivecredit.com/api/old`
      : `${location.origin}/api/old`
  } else {
    return config.API_DOMAIN_URL
  }
}
export default config
